import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Badge,
} from "reactstrap";
import { useCookieConsent } from "./CookieConsentProvider";
import { Switch } from "antd";

export default function CookieSettingsModal({ isOpen, toggle }) {
  const { consent, setThirdPartyMedia, acceptAll } = useCookieConsent();

  const cardStyle = {
    border: "1px solid rgba(15,23,42,0.08)",
    borderRadius: 14,
    padding: "18px",
    marginBottom: "14px",
    backgroundColor: "#f8fafc",
    transition: "all 0.2s ease",
  };

  const initialLocal = useMemo(
    () => ({
      thirdPartyMedia: consent.thirdPartyMedia,
    }),
    [consent.thirdPartyMedia],
  );

  const [localPrefs, setLocalPrefs] = useState(initialLocal);

  useEffect(() => {
    if (isOpen) setLocalPrefs(initialLocal);
  }, [isOpen, initialLocal]);

  const hasChanges = localPrefs.thirdPartyMedia !== consent.thirdPartyMedia;

  const handleSave = () => {
    if (hasChanges && localPrefs.thirdPartyMedia !== null) {
      setThirdPartyMedia(localPrefs.thirdPartyMedia);
    }
    toggle();
  };

  const handleAcceptAllTop = () => {
    acceptAll();
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle} className="border-0 pb-0">
        <span
          style={{ fontWeight: 800, fontSize: "1.25rem", color: "#1e293b" }}
        >
          Çerez Tercihlerinizi Yönetin
        </span>
      </ModalHeader>

      <ModalBody style={{ lineHeight: 1.6 }}>
        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 18 }}>
          Web sitemizin güvenli şekilde çalışması ve hizmet kalitesinin
          artırılması için çerezler kullanılmaktadır. Tercihlerinizi aşağıdan
          yönetebilirsiniz.{" "}
          <a
            href="/cerez-politikasi"
            style={{
              color: "#0284c7",
              fontWeight: 800,
              textDecoration: "underline",
              textUnderlineOffset: 3,
            }}
          >
            Daha fazla bilgi
          </a>
        </p>

        <div className="d-flex justify-content-end mb-3">
          <Button
            color="info"
            className="px-4 py-2 shadow-sm"
            style={{ borderRadius: "12px", fontWeight: 800, border: "none" }}
            onClick={handleAcceptAllTop}
          >
            Tümüne İzin Ver
          </Button>
        </div>

        {/* 1. KATEGORİ: ZORUNLU */}
        <div style={cardStyle}>
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ flex: 1, paddingRight: "10px" }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>
                Kesinlikle Gerekli Tanımlama Bilgileri
              </div>
              <div style={{ fontSize: 13, color: "#475569", marginTop: 4 }}>
                Web sitesinin çalışması ve güvenliği için gerekli temel
                işlevleri sağlar.
              </div>
            </div>
            <Badge
              color="light"
              className="text-black px-3 py-2 border"
              pill
              style={{ fontSize: 10 }}
            >
              HER ZAMAN AKTİF
            </Badge>
          </div>
        </div>

        {/* 2. KATEGORİ: İŞLEVSEL VE DIŞ İÇERİK */}
        <div style={cardStyle}>
          <div className="d-flex justify-content-between align-items-start">
            <div style={{ flex: 1, paddingRight: "10px" }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>
                İşlevsel Tanımlama Bilgileri
              </div>
              <div style={{ fontSize: 13, color: "#475569", marginTop: 6 }}>
                Video içerikleri ve haritalar gibi gelişmiş özelliklerin
                sunulmasını sağlar.
              </div>
            </div>
            <div
              className="d-flex align-items-center"
              style={{ paddingTop: 2 }}
            >
              <Switch
                checked={localPrefs.thirdPartyMedia === true}
                onChange={(checked) => {
                  setLocalPrefs((p) => ({ ...p, thirdPartyMedia: !!checked }));
                }}
                style={{
                  backgroundColor:
                    localPrefs.thirdPartyMedia === true ? "#22C55E" : undefined,
                }}
              />
            </div>
          </div>
        </div>
      </ModalBody>

      <ModalFooter
        className="border-0 px-4 pb-4 mt-2 justify-content-end align-items-center"
        style={{ backgroundColor: "#f8fafc" }}
      >
        <Button
          color="info"
          className="px-5 py-2 shadow-sm"
          style={{
            borderRadius: "12px",
            fontWeight: 800,
            border: "none",
          }}
          onClick={handleSave}
        >
          Seçimleri Kaydet
        </Button>
      </ModalFooter>
    </Modal>
  );
}
